import { Component, inject, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { PropertyComponent } from '../../main/property/property.component';
import { SettingWithMetadata } from '../../models';
import { ChargerSettingsService } from '../charger-settings.service';
import { ChargersService } from '../chargers.service';

@Component({
	selector: 'app-charger-settings-installer',
	imports: [MatListModule, MatProgressSpinnerModule, MatIconModule, MatFormFieldModule, MatSelectModule, MatOptionModule, MatInputModule, MatSnackBarModule, PropertyComponent, MatCardModule],
	templateUrl: './charger-settings-installer.component.html',
	styleUrl: './charger-settings-installer.component.scss'
})
export class ChargerSettingsInstallerComponent {
	chargerId!: string;
	chargerProperties = signal<SettingWithMetadata[]>([]);
	chargerPropertiesLoaded = signal<boolean>(false);

	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private chargersService = inject(ChargersService);
	private snackBar = inject(MatSnackBar);
	private chargerSettingsService = inject(ChargerSettingsService);


	ngOnInit() {
		this.chargerId = this.route.parent?.snapshot.paramMap.get('id') ?? '';
		const isValid = /^[PD]\d{14}$/.test(this.chargerId);
		if (!isValid) {
			this.router.navigate(['/404']);
		}

		this.chargersService.getChargerSettingsInstaller(this.chargerId).subscribe((charger) => {
			console.log('getChargerSettingsInstaller():', charger);

			this.chargerProperties.set([
				{
					id: 'chargerConnectionMaximumCurrent',
					name: $localize`:@@ChargerConnectionMaximumCurrent:Charger Connection Maximum Current` + ' [A]',
					valueWithMetadata: charger.chargerConnectionMaximumCurrent,
					type: 'number'
				},
				{
					id: 'homeConnectionMaximumCurrent',
					name: $localize`:@@HomeConnectionMaximumCurrent:Home Connection Maximum Current` + ' [A]',
					valueWithMetadata: charger.homeConnectionMaximumCurrent,
					type: 'number'
				},
				{
					id: 'powerSharingConfiguration',
					name: $localize`:@@PowerSharingConfiguration:PowerSharing Configuration`,
					valueWithMetadata: charger.powerSharingConfiguration,
					type: 'string'
				},
				{
					id: 'isSensorBoxPresent',
					name: $localize`:@@IsSensorBoxPresent:Is SensorBox Present`,
					valueWithMetadata: charger.isSensorBoxPresent,
					type: 'boolean'
				},
				{
					id: 'solarNumberOfPhases',
					name: $localize`:@@SolarNumberOfPhases:Solar Number Of Phases`,
					valueWithMetadata: charger.solarNumberOfPhases,
					type: 'string'
				},
			]);
			console.log('getChargerSettingsInstaller() chargerProperties:', this.chargerProperties());
			this.chargerPropertiesLoaded.set(true);
		});
	}


	saveCallback = (setting: SettingWithMetadata) => this.saveSetting(setting); // for preserving `this` context in `saveSetting`

	saveSetting(setting: SettingWithMetadata): Observable<boolean> {
		console.log('saveSetting():', setting);
		let value;
		if ((setting.valueWithMetadata) && ('value' in setting.valueWithMetadata)) {
			value = setting.valueWithMetadata?.value;
		}

		if (setting && value !== null) {
			return this.chargersService.putChargerSettingsInstaller(this.chargerId, setting.id, value).pipe(
				map(result => {
					return this.chargerSettingsService.openSnackbar(this.snackBar, result.success, result.errorMessage);
				}),
				catchError(err => {
					return of(this.chargerSettingsService.openSnackbar(this.snackBar, false, err.message));
				})
			);
		}
		console.log('saveSetting() skipped — setting or value invalid:', setting, value);
		return of(false);
	}
}
